module.exports = __webpack_public_path__ + "static/media/insect(5).b3360e96.PNG";